// App.js
import React, { useState } from 'react';
import HomePage from './components/HomePage';
import HomeScreen from './components/HomeScreen';
import Viewer from './components/Viewer';
import About from './components/About';
import Subject from './components/Subject';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import Profile from './components/Auth/Profile';
import StudyTools from './components/StudyTools/StudyTools';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import './App.css';
import { getSubjects, getYears, getSessions, getPapers } from './api';
import { pdfjs } from 'react-pdf';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;


function App() {
  const [curriculum, setCurriculum] = useState('');
  const [subject, setSubject] = useState('');
  const [year, setYear] = useState('');
  const [session, setSession] = useState('');
  const [papers, setPapers] = useState([]);
  const [viewMode, setViewMode] = useState('qp');

  const handleSearch = async () => {
    const papers = await getPapers(curriculum, subject, year, session);
    setPapers(papers);
  };

  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/subject" element={<Subject />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/study-tools" element={
              <ProtectedRoute>
                <StudyTools />
              </ProtectedRoute>
            } />
            <Route path="/profile" element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/papers" element={
              <HomeScreen
                curriculum={curriculum}
                setCurriculum={setCurriculum}
                subject={subject}
                setSubject={setSubject}
                year={year}
                setYear={setYear}
                session={session}
                setSession={setSession}
                onSearch={handleSearch}
                papers={papers}
              />
            } />
            <Route path="/viewer" element={
              <Viewer
                viewMode={viewMode}
                setViewMode={setViewMode}
              />
            } />
          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;